import { render } from "./MostWanted.vue?vue&type=template&id=4aff818d&scoped=true&bindings={\"images\":\"data\",\"timer\":\"data\",\"currentIndex\":\"data\",\"title\":\"data\",\"next\":\"options\",\"prev\":\"options\",\"getUserData\":\"options\",\"currentImg\":\"options\"}"
import script from "./MostWanted.vue?vue&type=script&lang=js"
export * from "./MostWanted.vue?vue&type=script&lang=js"

import "./MostWanted.vue?vue&type=style&index=0&id=4aff818d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4aff818d"

export default script